import React, { useContext } from 'react';
import { SettingsOptionsContext } from 'contexts/SettingsOptionsContext';
import { QueryStringContext } from 'contexts/QueryStringContext';
import {
	getCurrencySymbolFromOptions,
	getDateRangeMonthYearSrc,
	getDateRangeMonthYearState,
	getMinMaxDatesFromData,
} from '../utils';
import { CategoryManagementContextProvider } from 'contexts/CategoryManagementContext/CategoryManagementContextProvider';
import { SettingsContext } from 'contexts/SettingsContext';
/**
 * withCategoryManagementProviders HOC Component
 * @param {JSX} WrappedComponent - Accepts a component and gives a Wrapped componets with Context Providers
 */

// Higher Order Component (HOC) that wraps a component with multiple providers
const withCategoryManagementProviders = WrappedComponent => {
	// Return a new component with added context providers
	return function CategoryManagementWrapper(props) {
		const { options } = useContext(SettingsOptionsContext);
		const { dateFrom, dateTo } = useContext(QueryStringContext);
		const { dateRanges } = options;
		const { minDate, maxDate } = getMinMaxDatesFromData(dateRanges);
		const wholeRange = getDateRangeMonthYearSrc(minDate, maxDate);
		const selectedRange = getDateRangeMonthYearState(dateFrom, dateTo);
		const {
			options: { currency: currencyList },
		} = useContext(SettingsOptionsContext);
		const { currency } = useContext(QueryStringContext);
		const currencySymbol = getCurrencySymbolFromOptions(currencyList, currency);
		const { hideDecimals } = useContext(SettingsContext);

		return (
			<>
				<CategoryManagementContextProvider
					dateRangeData={{ wholeRange, selectedRange }}
					currencySymbol={currencySymbol}
					hideDecimals={hideDecimals}
				>
					<WrappedComponent {...props} />
				</CategoryManagementContextProvider>
			</>
		);
	};
};

export default withCategoryManagementProviders;
